'helper'.trashAll('Inventory')
'helper'.trashAll('PO')
'helper'.trashAll('Supplier')
'helper'.addProduct({name: 'Hat', sku: 'HAT01'})
'helper'.addProduct({name: 'Coat', sku: 'COAT01'})
'helper'.addProduct({name: 'Scarf', sku: 'SCARF01'})
'helper'.addProduct({name: 'Bonnet', sku: 'BONNET01'})
'helper'.addProduct({name: 'Brooch', sku: 'BROOCH01'})
'helper'.addProduct({name: 'Kerchief', sku: 'KERCHIEF01'})
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('A')
    'Add another'.click()
    'Name'.enter('B')
    'Add another'.click()
    'Name'.enter('C')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Supplier'.enter('A')
    'Order Date'.enter('01/01/2021')
    'Add Line'.click()
      'Product'.enter('Hat (HAT01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('50.00')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Supplier'.enter('A')
    'Order Date'.enter('02/01/2021')
    'Add Line'.click()
      'Product'.enter('Coat (COAT01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('240.00')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00003')
    'Supplier'.enter('B')
    'Order Date'.enter('03/01/2021')
    'Add Line'.click()
      'Product'.enter('Scarf (SCARF01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('20.00')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00004')
    'Supplier'.enter('B')
    'Order Date'.enter('04/01/2021')
    'Add Line'.click()
      'Product'.enter('Bonnet (BONNET01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('30.00')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00005')
    'Supplier'.enter('C')
    'Order Date'.enter('05/01/2021')
    'Add Line'.click()
      'Product'.enter('Brooch (BROOCH01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('110.00')
      'OK'.click()
    'OK'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00006')
    'Supplier'.enter('C')
    'Order Date'.enter('06/01/2021')
    'Add Line'.click()
      'Product'.enter('Kerchief (KERCHIEF01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('10.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(0)
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00007')
    'Supplier'.enter('A')
    'Order Date'.enter('06/01/2021')
    'Add Line'.click()
      'Product'.enter('Hat (HAT01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('50.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(0)
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00008')
    'Supplier'.enter('A')
    'Order Date'.enter('07/01/2021')
    'Add Line'.click()
      'Product'.enter('Hat (HAT01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('55.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(1)
    'mainTable.0.Supplier'.shouldEqual('A')
    'mainTable.0.Product'.shouldEqual('Hat (HAT01)')
    'mainTable.0.Date'.shouldEqual('Jan 7 2021')
    'mainTable.0.Old Price'.shouldEqual('50.00')
    'mainTable.0.New Price'.shouldEqual('55.00')
    'mainTable.0.Increase amount'.shouldEqual('5.00')
    'mainTable.0.Increase %'.shouldEqual('10.0')
    'mainTable.0.Old PO'.shouldEqual('PO00007')
    'mainTable.0.New PO'.shouldEqual('PO00008')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00009')
    'Supplier'.enter('B')
    'Order Date'.enter('08/01/2021')
    'Add Line'.click()
      'Product'.enter('Scarf (SCARF01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('20.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(1)
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00010')
    'Supplier'.enter('B')
    'Order Date'.enter('09/01/2021')
    'Add Line'.click()
      'Product'.enter('Scarf (SCARF01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('25.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(2)
    'mainTable.1.Supplier'.shouldEqual('B')
    'mainTable.1.Old Price'.shouldEqual('20.00')
    'mainTable.1.New Price'.shouldEqual('25.00')
    'mainTable.1.Increase amount'.shouldEqual('5.00')
    'mainTable.1.Increase %'.shouldEqual('25.0')
    'mainTable.1.Old PO'.shouldEqual('PO00009')
    'mainTable.1.New PO'.shouldEqual('PO00010')
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00011')
    'Supplier'.enter('C')
    'Order Date'.enter('10/01/2021')
    'Add Line'.click()
      'Product'.enter('Brooch (BROOCH01)')
      'Quantity'.enter('1')
      'Unit Price (Inc Tax)'.enter('99.00')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
  'mainTable./Purchase Price Changes/.Run'.click()
    'mainTable'.shouldHaveCount(3)
    'mainTable.2.Supplier'.shouldEqual('C')
    'mainTable.2.Increase %'.shouldEqual('-10.0')
    'mainTable.2.Old PO'.shouldEqual('PO00005')
    'mainTable.2.New PO'.shouldEqual('PO00011')
    'Back'.click()
  'Back'.click()
'helper'.trashAll('Inventory')
'helper'.trashAll('PO')
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Add Line'.click()
      'Product'.enter('Hat (HAT01)')
      'Quantity'.enter('1')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_inventory'.click()
  'searcher'.enter('at')
  'mainTable./Hat (HAT01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Coat (COAT01)/.Quantity On Hand'.shouldEqual('0')
  'mainTable./Coat (COAT01)/.Adjust Qty'.click()
    'Quantity'.enter('1')
    'OK'.click()
  'mainTable./Coat (COAT01)/.Quantity On Hand'.shouldEqual('1')
  'mainTable./Hat (HAT01)/.Trash'.shouldntExist()
  'Process Bulk Trash'.shouldntExist()
  'Bulk Trash'.click()
    'mainTable./Hat (HAT01)/.Bulk Trash'.shouldExist()
    'Process Bulk Trash'.shouldExist()
    'Back'.click()
  'mainTable./Hat (HAT01)/.Bulk Trash'.shouldntExist()
  'Process Bulk Trash'.shouldntExist()
  'Bulk Trash'.click()
    'Process Bulk Trash'.click()
      'messageDialogText'.shouldEqual("No products are selected - please tick at least one then try again", 'doc')
      'messageDialogOK'.click('doc')
    'mainTable./Hat (HAT01)/.Bulk Trash'.toggleTick()
    'mainTable./Coat (COAT01)/.Bulk Trash'.toggleTick()
    'Process Bulk Trash'.click()
      'messageDialogText'.shouldEqual("Product 'Coat (COAT01)' has non-zero Quantity On Hand - please untick and try again", 'doc')
      'messageDialogOK'.click('doc')
    'mainTable./Coat (COAT01)/.Bulk Trash'.toggleTick()
    'Process Bulk Trash'.click()
      'messageDialogText'.shouldEqual("Product 'Hat (HAT01)' has non-zero Quantity On Purchase Orders - please untick and try again", 'doc')
      'messageDialogOK'.click('doc')
    'stocktend_purchaseOrders'.click()
      'mainTable./PO00001/.Trash'.click()
      'mainTable./PO00001/.Really Trash?'.click()
      'Back'.click()
    'Process Bulk Trash'.click()
      'messageDialogText'.shouldEqual("Trashing 1 products - are you sure?", 'doc')
      'messageDialogNo'.click('doc')
    'searcher'.enter('Hat (HAT01)')
    'mainTable'.shouldHaveCount(2) // Including Total
    'Process Bulk Trash'.click()
      'messageDialogText'.shouldEqual("Trashing 1 products - are you sure?", 'doc')
      'messageDialogYes'.click('doc')
    'mainTable'.shouldHaveCount(0)
    'Back'.click()
  'searcher'.enter('Coat (COAT01)')
  'mainTable'.shouldHaveCount(2) // Including Total
  'Back'.click()
'helper'.trashAll('PO')
'helper'.trashAll('Inventory')
'helper'.trashAll('Configuration')
'stocktend_settings'.click()
  'Default Tax %'.enter('10')
  'OK'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00001')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('10')
      'Unit Price (Inc Tax)'.enter('50.00')
      'Add another line'.click()
      'Product'.enter('Hoodie (H01)')
      'Quantity'.enter('10')
      'Unit Price (Inc Tax)'.enter('50.00')
      'OK'.click()
    'Order Total (Inc Tax)'.shouldEqual('1,000.00')
    'Lines./Cap (C01)/.Line Total (Inc Tax)'.shouldEqual('500.00')
    'Lines./Cap (C01)/.Quantity'.enter('11')
    'Order Total (Inc Tax)'.shouldEqual('1,050.00')
    'Lines./Cap (C01)/.Line Total (Inc Tax)'.shouldEqual('550.00')
    'Lines./Hoodie (H01)/.Unit Price (Inc Tax)'.enter('60')
    'Lines./Cap (C01)/.Unit Price (Inc Tax)'.enter('55')
    'Lines./Cap (C01)/.Line Total (Inc Tax)'.shouldEqual('605.00')
    'OK'.click()
  'mainTable./PO00001/.Edit'.click()
    'Lines./Cap (C01)/.Quantity'.shouldEqual('11')
    'Lines./Hoodie (H01)/.Unit Price (Inc Tax)'.shouldEqual('60.00')
    'Lines./Cap (C01)/.Unit Price (Inc Tax)'.shouldEqual('55.00')
    'Lines./Hoodie (H01)/.Unit Price (Inc Tax)'.enter('44')
  'Back'.click()
'stocktend_settings'.click()
  'Enter Purchase Prices Inclusive Of Tax'.enter('No')
  'OK'.click()
'stocktend_purchaseOrders'.click()
  'Add'.click()
    'Purchase Order Number'.enter('PO00002')
    'Add Line'.click()
      'Product'.enter('Cap (C01)')
      'Quantity'.enter('10')
      'Unit Price (Excl Tax)'.enter('50.00')
      'OK'.click()
    'Order Total (Inc Tax)'.shouldEqual('550.00')
    'Lines./Cap (C01)/.Line Total (Excl Tax)'.shouldEqual('500.00')
    'Lines./Cap (C01)/.Unit Price (Excl Tax)'.enter('55')
    'Lines./Cap (C01)/.Line Total (Excl Tax)'.shouldEqual('550.00')
    'OK'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Edit'.click()
    'Lines./Hoodie (H01)/.Unit Price (Inc Tax)'.shouldEqual('44.00')
    'OK'.click()
  'Back'.click()
'stocktend_settings'.click()
  'Enter Purchase Prices Inclusive Of Tax'.enter('Yes')
  'OK'.click()
'stocktend_receivePurchases'.click()
  'mainTable./PO00001/.Enter Receipt'.click()
    'Lines./Cap (C01)/.Received'.shouldEqual('11')
    'Lines./Cap (C01)/.Received'.enter('10')
    'Lines./Cap (C01)/.Unit Price (Inc Tax)'.shouldEqual('55.00')
    'Lines./Cap (C01)/.Unit Price (Inc Tax)'.enter('44.00')
    'OK'.click()
  'Back'.click()
'stocktend_receivePurchases'.click()
  'View All Receipts'.click()
    'mainTable./PO00001-01/.Edit'.click()
      'Lines./Cap (C01)/.Received'.shouldEqual('10')
      'Lines./Cap (C01)/.Unit Price (Inc Tax)'.shouldEqual('44.00')
      'Lines./Cap (C01)/.Received'.enter('11')
      'OK'.click()
    'Back'.click()
  'Back'.click()
'stocktend_purchaseOrders'.click()
  'mainTable./PO00001/.Status'.shouldEqual('Received')
  'Back'.click()
'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('Configuration')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.trashAll('Avenue')
'helper'.trashAll('Supplier')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'stocktend_settings'.click()
'Short Date Format'.enter('dd/mm/yyyy')
'OK'.click()
'stocktend_suppliers'.click()
'Add'.click()
'Name'.enter('Castaways')
'Minimum Order Value'.enter('100')
'Save'.click()
'Add another'.click()
'Name'.enter('Bombast Corporation')
'Save'.click()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Product'.click()
'Add Supplier'.click()
'Supplier'.enter('Castaways')
'Barcode'.enter('RFT918273645')
'Minimum Order Quantity'.enter('15')
'OK'.click()
'OK'.click()
'mainTable./Shórts - Red (SR01)/.Product'.click()
'Add Supplier'.click()
'Supplier'.enter('Castaways')
'Barcode'.enter('1111')
'Minimum Order Quantity'.enter('15')
'OK'.click()
'OK'.click()
'searcher'.enter('')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00002')
'Supplier'.enter('Castaways')
'Expected Delivery Date'.enterExpression('global.todayLocal().incDays(-70)')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('10')
'Unit Price (Inc Tax)'.enter('9.99')
'Add another line'.click()
'Product'.chooseOption('Shórts - Red (SR01)')
'Quantity'.enter('2')
'OK'.click()
'OK'.click()
'messageDialogText'.shouldEqual("WARNING: Supplier minimum order value is 100.00 (this order's value is only 99.90)", 'doc')
'messageDialogOK'.click('doc')
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Product'.click()
'Suppliers./Castaways/.Edit'.click()
'Minimum Order Quantity'.enter('0')
'OK'.click()
'OK'.click()
'searcher'.enter('')
'Back'.click()
'stocktend_suppliers'.click()
'mainTable./Castaways/.Edit'.click()
'Minimum Order Value'.enter('0')
'OK'.click()
'Back'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00003')
'Expected Delivery Date'.enterExpression('global.todayLocal().incDays(7)')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('7')
'OK'.click()
'OK'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00004')
'Expected Delivery Date'.enterExpression('global.todayLocal()')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('11')
'OK'.click()
'OK'.click()
'Receive Purchases'.click()
  'mainTable./PO00002/.Enter Receipt'.click()
    'Lines./Shórts - Blue (SB01)/.Received'.shouldEqual('10')
    'Lines./Shórts - Red (SR01)/.Received'.shouldEqual('2')
    'Scan Status'.shouldntExist()
    'Scan Products In'.click()
    'Lines./Shórts - Blue (SB01)/.Received'.shouldEqual('0')
    'Lines./Shórts - Red (SR01)/.Received'.shouldEqual('0')
    'Scan Status'.shouldEqual('Ready for you to start scanning')
    'helper'.simulateScannerRead('abcd')
    'Scan Status'.shouldEqual('Scanned code unrecognized: abcd')
    'helper'.simulateScannerRead('RFT918273645')
      'Edit Receipt Line'.shouldBeCurrentPage()
      'Product'.shouldEqual('Shórts - Blue (SB01)')
      'Received'.shouldEqual('1')
      'Scan Status'.shouldEqual('Received 1 of Shórts - Blue (SB01)')
      'helper'.simulateScannerRead('abcd')
      'Scan Status'.shouldEqual('Scanned code unrecognized: abcd')
      'helper'.simulateScannerRead('RFT918273645')
      'Scan Status'.shouldEqual('Received 2 of Shórts - Blue (SB01)')
      'Received'.shouldEqual('2')
      'helper'.simulateScannerRead('1111')
      'Product'.shouldEqual('Shórts - Red (SR01)')
      'Scan Status'.shouldEqual('Received 1 of Shórts - Red (SR01)')
      'helper'.simulateScannerRead('1111')
      'Product'.shouldEqual('Shórts - Red (SR01)')
      'Scan Status'.shouldEqual('Received 2 of Shórts - Red (SR01)')
      'Received'.enter('0')
      'OK'.click()
    'Add Purchase Order Receipt'.shouldBeCurrentPage()
    'helper'.simulateScannerRead('RFT918273645')
      'Edit Receipt Line'.shouldBeCurrentPage()
      'Product'.shouldEqual('Shórts - Blue (SB01)')
      'Scan Status'.shouldEqual('Received 3 of Shórts - Blue (SB01)')
      'Received'.shouldEqual('3')
      'Received'.enter('1')
      'OK'.click()
    'OK'.click()
  'Back'.click()
'stocktend_reports'.click()
'mainTable./Overdue Purchase Order Stock/.Run'.click()
'mainTable'.shouldHaveCount(4) // including total row
'Overdue Purchase Order Stock'.shouldBeCurrentPage()
'mainTable.1.Purchase Order'.shouldEqual('PO00002')
'mainTable./Shórts - Blue (SB01)/.Outstanding Quantity'.shouldEqual('9')
'mainTable./Shórts - Blue (SB01)/.Days Overdue'.shouldBeBetween('70', '71')
'mainTable./Shórts - Blue (SB01)/.Status'.shouldEqual('Partially Received')
'mainTable.2.Purchase Order'.shouldEqual('PO00002')
'mainTable./Shórts - Red (SR01)/.Outstanding Quantity'.shouldEqual('2')
'mainTable./Shórts - Red (SR01)/.Days Overdue'.shouldBeBetween('70', '71')
'mainTable./Shórts - Red (SR01)/.Status'.shouldEqual('Partially Received')
'mainTable.3.Product'.shouldEqual('Shórts - Blue (SB01)')
'mainTable.3.Purchase Order'.shouldEqual('PO00004')
'mainTable.3.Outstanding Quantity'.shouldEqual('11')
'mainTable.3.Days Overdue'.shouldEqual('0')
'mainTable.3.Status'.shouldEqual('Awaiting Delivery')
'Receive Purchases'.click()
'mainTable./PO00002/.Enter Receipt'.click()
'OK'.click()
'stocktend_reports'.click()
'mainTable./Overdue Purchase Order Stock/.Run'.click()
'mainTable'.shouldHaveCount(2)
'mainTable.1.Product'.shouldEqual('Shórts - Blue (SB01)')
'mainTable.1.Purchase Order'.shouldEqual('PO00004')
'mainTable.1.Outstanding Quantity'.shouldEqual('11')
'mainTable.1.Days Overdue'.shouldEqual('0')
'stocktend_purchaseOrders'.click()
'helper'.trashAll('POReceiptLine')
'helper'.trashAll('POReceipt')
'helper'.trashAll('POLine')
'helper'.trashAll('PO')
'helper'.trashAll('Inventory')
'helper'.trashAll('Transaction')
'helper'.clearWCStockLevels()
'helper'.flushCache()
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00002')
'Supplier'.chooseOption('Castaways')
'Expected Delivery Date'.enterExpression('global.todayLocal().incDays(7)')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('10')
'Add another line'.click()
'Product'.chooseOption('Shórts - Red (SR01)')
'Quantity'.enter('2')
'OK'.click()
'OK'.click()
'stocktend_reports'.click()
'mainTable./Purchase Orders/.Run'.click()
'Purchase Orders Report'.shouldBeCurrentPage()
'mainTable./PO00002/.Supplier'.shouldEqual('Castaways')
'Back'.click()
'stocktend_inventory'.click()
  'searcher'.enter('s')
  'mainTable./Shórts - Blue (SB01)/.View History'.click()
    'View Purchase Order Lines'.click()
      'Purchase Order Lines'.shouldBeCurrentPage()
      'mainTable'.shouldHaveCount(1)
      'mainTable.0.Purchase Order'.shouldEqual('PO00002')
      'mainTable.0.Ordered Quantity'.shouldEqual('10')
      'Back'.click()
    'Back'.click()
  'searcher'.enter('')
  'Back'.click()
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Awaiting Delivery')
'mainTable.1.View Receipts'.shouldntExist()
'mainTable.1.Enter Receipt'.click()
'Add Purchase Order Receipt'.shouldBeCurrentPage()
'Receipt Number'.shouldEqual('PO00002-01')
'Lines'.shouldHaveCount(2)
'Lines.0.Description'.shouldEqual('Shórts - Blue (SB01)')
'Lines.0.Received'.shouldEqual('10')
'Lines.1.Description'.shouldEqual('Shórts - Red (SR01)')
'Lines.1.Received'.shouldEqual('2')
'Lines.0.Edit'.click()
'Received'.enter('6')
'OK'.click()
'Save'.shouldntHaveError()
'Add Purchase Order Receipt'.shouldBeCurrentPage()
'OK'.click()
'Receive Purchases'.shouldBeCurrentPage()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('6')
'Receive Purchases'.click()
'mainTable.1.Purchase Order Number'.shouldEqual('PO00002')
'mainTable.1.Status'.shouldEqual('Partially Received')
'mainTable.1.View Receipts'.click()
'View Receipts for Purchase Order PO00002'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(1)
'mainTable.0.Receipt Number'.shouldEqual('PO00002-01')
'mainTable.0.Edit'.click()
'Edit Purchase Order Receipt'.shouldBeCurrentPage()
'Lines'.shouldHaveCount(2)
'Lines.0.Edit'.click()
'Received'.enter('3')
'OK'.click()
'OK'.click()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('3')
'Receive Purchases'.click()
'mainTable.1.View Receipts'.click()
'mainTable.0.Edit'.click()
'Lines.0.Trash'.click()
'Lines.0.Really Trash?'.click()
'Save'.click()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('0')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('2')
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Partially Received')
'mainTable.1.View Receipts'.click()
'View Receipts for Purchase Order PO00002'.shouldBeCurrentPage()
'mainTable.0.Trash'.click()
'mainTable.0.Really Trash?'.click()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('0')
'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('0')
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Awaiting Delivery')
'mainTable.1.Enter Receipt'.click()
'Lines.0.Trash'.click()
'Lines.0.Really Trash?'.click()
'Save'.click()
'Receive Purchases'.click()
'mainTable.1.View Receipts'.click()
'mainTable.0.Trash'.click()
'mainTable.0.Really Trash?'.click()
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Quantity On Hand'.shouldEqual('0')
'mainTable./Shórts - Red (SR01)/.Quantity On Hand'.shouldEqual('0')
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Awaiting Delivery')
'mainTable.1.Enter Receipt'.click()
'Lines.0.Trash'.click()
'Lines.0.Really Trash?'.click()
'Save'.click()
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Partially Received')
'mainTable.1.View Receipts'.click()
'mainTable.0.Edit'.click()
'Lines.0.Trash'.click()
'Lines.0.Really Trash?'.click()
'Save'.click()
'Receive Purchases'.click()
'mainTable.1.Status'.shouldEqual('Awaiting Delivery')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00003');
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Quantity'.enter('10')
'OK'.click()
'OK'.click()
'Receive Purchases'.click()
'mainTable./PO00003/.Enter Receipt'.click()
'Lines.0.Edit'.click()
'Received'.enter('4')
'Outstanding Quantity'.shouldBeReadOnly()
'Outstanding Quantity'.shouldEqual('6')
'Cancelled Quantity'.shouldEqual('0')
'Cancelled Quantity'.enter('7')
'OK'.click()
'stFormRejection'.shouldContain('You cannot cancel more than the quantity left on order')
'Cancelled Quantity'.enter('2')
'Outstanding Quantity'.shouldEqual('4')
'OK'.click()
'OK'.click()
'mainTable./PO00003/.View Receipts'.click()
'mainTable'.shouldHaveCount(1)
"Back".click()
'View All Receipts'.click()
'View Receipts'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(2)
'Inventory'.click()
'searcher'.enter('s')
'mainTable./Shórts - Red (SR01)/.On Purchase Orders'.shouldEqual('2')
'mainTable./Shórts - Blue (SB01)/.On Purchase Orders'.shouldEqual('14')
'stocktend_purchaseOrders'.click()
'mainTable./PO00003/.Edit'.click()
'Lines./Shórts - Blue (SB01)/.Edit'.click()
'Cancelled Quantity'.shouldEqual('2')
'Cancelled Quantity'.shouldBeReadOnly()
'Back'.click()
'Status'.shouldEqual('Partially Received')
'Receive Purchases'.click()
'mainTable./PO00003/.View Receipts'.click()
'mainTable.0.Edit'.click()
'Lines.0.Edit'.click()
'Cancelled Quantity'.shouldEqual('2')
'Outstanding Quantity'.shouldEqual('4')
'Cancelled Quantity'.enter('6')
'Outstanding Quantity'.shouldEqual('0')
'OK'.click()
'OK'.click()
'stocktend_purchaseOrders'.click()
'mainTable./PO00003/.Status'.shouldEqual('Received')
'stocktend_reports'.click()
'mainTable./Purchase Orders/.Run'.click()
'mainTable./PO00002/.Supplier'.shouldEqual('Castaways')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00004');
'Order Date'.enter('1/1/2020')
'Add Line'.click()
'Product'.chooseOption('Hoodie (H01)')
'Quantity'.enter('17')
'OK'.click()
'OK'.click()
'stocktend_reports'.click()
'mainTable./Purchase Orders/.Run'.click()
'From Date'.enter('2/1/2020')
'Go'.click()
'mainTable./PO00004/'.shouldntExist()
'From Date'.enter('1/1/2020')
'Go'.click()
'mainTable./PO00004/.Ordered Quantity'.shouldEqual('17')
'stocktend_reports'.click()
'mainTable./Overdue Purchase Order Stock/.Run'.click()
'mainTable'.shouldHaveCount(2)
'Overdue Purchase Order Stock'.shouldBeCurrentPage()
'mainTable./Hoodie (H01)/.Outstanding Quantity'.shouldEqual('17')
'mainTable./Hoodie (H01)/.Days Overdue'.shouldEqual('0')
